import React from 'react';
import { cdn } from '../../helpers/cdn';
import injectSheet from 'react-jss';
import PropTypes from 'prop-types';

const propTypes = {
    classes: PropTypes.object.isRequired,
    type: PropTypes.string.isRequired,
    size: PropTypes.string
};
const Loader = ({classes, type, size = 'normal'}) => {
    const iconSrc = cdn(`loaders/table-blue-loader.svg`);

    return (
        <div className={classes[size]}>
            <img src={iconSrc} />
        </div>
    );
};

const styles = theme => ( {
    normal: {
        height: '100%',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    }
} );

Loader.propTypes = propTypes;

export default injectSheet(styles)(Loader);




// WEBPACK FOOTER //
// ./src/app/components/loader/Loader.js